import { Spinner } from '../../../../Templates/_UI/Kit/Feedback';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUserAuthenticated } from '../userAuthenticatedContext';
import { getUserAccess } from '../../../../../HELPERS/_moduleFactory.helper';

const useAcceso = () => {

    const { useDataUserAuth } = useUserAuthenticated();

    const SESION = useDataUserAuth ?? {};
    const ACCESO = getUserAccess(SESION.data ?? {});

    const onTieneRol = (roles) => {
        if (!roles || roles.length === 0) return true;
        if (ACCESO.isGod) return true;
        return (Array.isArray(roles) ? roles : [roles]).some((r) => ACCESO.roleKeys.has(r));
    };

    const onTienePermiso = (permisos) => {
        if (!permisos || permisos.length === 0) return true;
        if (ACCESO.isGod) return true;
        return (Array.isArray(permisos) ? permisos : [permisos]).some((p) => ACCESO.permKeys.has(p));
    };

    const onTieneTodos = (permisos) => {
        if (!permisos || permisos.length === 0) return true;
        if (ACCESO.isGod) return true;
        return (Array.isArray(permisos) ? permisos : [permisos]).every((p) => ACCESO.permKeys.has(p));
    };

    return {
        isAuth: Boolean(SESION.isAuthenticated),
        isLoading: Boolean(SESION.isLoading),
        hasRole: onTieneRol,
        hasPermission: onTienePermiso,
        hasEveryPermission: onTieneTodos,
    };
};


export const AppGuard = ({ children, roles = null, permissions = null, requireAll = false,
    redirectTo = '/ingresar', forbiddenTo = '/sin-permiso', fallback = null,
}) => {

    const { isAuth, isLoading, hasRole, hasPermission, hasEveryPermission } = useAcceso();

    const location = useLocation();

    if (isLoading) {
        return fallback ?? <Spinner label="Verificando sesión…" />;
    }

    if (!isAuth) {
        return <Navigate to={redirectTo} state={{ from: location }} replace />;
    }

    const HAS_ROLE = hasRole(roles);

    const HAS_PERMS = requireAll ? hasEveryPermission(permissions) : hasPermission(permissions);

    if (!HAS_ROLE || !HAS_PERMS) {
        return <Navigate to={forbiddenTo} replace />;
    }

    return children ?? <Outlet />;
};


export const AppGuestGuard = ({ children, redirectTo = '/dashboard' }) => {

    const { isAuth, isLoading } = useAcceso();

    const location = useLocation();

    if (isLoading) return <Spinner label="Verificando sesión…" />;

    if (isAuth) {
        const BACK = location.state?.from?.pathname;
        return <Navigate to={BACK ?? redirectTo} replace />;
    }

    return children ?? <Outlet />;
};

export const AppCan = ({ children, roles = null, permissions = null, requireAll = false, fallback = null }) => {

    const { isAuth, hasRole, hasPermission, hasEveryPermission } = useAcceso();

    if (!isAuth) return fallback;

    const HAS_PERMS = requireAll ? hasEveryPermission(permissions) : hasPermission(permissions);

    if (!hasRole(roles) || !HAS_PERMS) return fallback;

    return children;
};
